import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addItem: {
		id: 'issue-field-service-entity.add-item',
		defaultMessage: 'Add service',
		description: 'Text for button that adds another service',
	},
	removeItem: {
		id: 'issue-field-service-entity.remove-item',
		defaultMessage: 'Remove service',
		description: 'Text for button that removes a service',
	},
	editField: {
		id: 'issue-field-service-entity.edit-field',
		defaultMessage: 'Edit Field',
		description: 'Label for button icon that, when clicked, will begin editing a field',
	},
	showDetails: {
		id: 'issue-field-service-entity.show-details',
		defaultMessage: 'Show details',
		description: 'Label/Tooltip for button icon that shows objects for a Insight field',
	},
	hideDetails: {
		id: 'issue-field-service-entity.hide-details',
		defaultMessage: 'Hide details',
		description: 'Label/Tooltip for button icon that hides objects for a Insight field',
	},
	itemCount: {
		id: 'issue-field-service-entity.item-count',
		defaultMessage: '{count, plural, one {# Service} other {# Services}}',
		description: 'Text for the number of objects in the Insight field',
	},
	searchPlaceholder: {
		id: 'issue-field-service-entity.search-placeholder',
		defaultMessage: 'Select or search for a service',
		description: 'Placeholder text shown in a search box for looking up Insight Objects',
	},
	infoSingleItemMessage: {
		id: 'issue-field-service-entity.info-single-item-message',
		defaultMessage: 'This field can only store a single service',
		description: 'Info message informing user that the service field can only have 1 service',
	},
	warningMultipleItemMessage: {
		id: 'issue-field-service-entity.warning-multiple-item-message',
		defaultMessage:
			'This field is configured to store a single object. Remove some services to save changes.',
		description:
			'Warning message that alert user of having multiple services in a single service field',
	},
	globalErrorMessage: {
		id: 'issue-field-service-entity.global-error-message',
		defaultMessage: 'We couldn’t retrieve the affected service details.',
		description: 'Error message when reading affected services fails.',
	},
});
